"use client";
import { getAffiliateExpiration } from "@lib/data/affiliate";
import { useSearchParams } from "next/navigation";
import { useEffect } from "react";

interface AffiliateTrackerProps {
  durationInHours: number;
}

export function AffiliateTracker({ durationInHours }: AffiliateTrackerProps) {
 const search = useSearchParams();
 const aff = search.get("aff-ref");

 useEffect(() => {
    if (!aff) return;

    const fetchExpiry = async () => {
      try {
        const maxAgeSeconds = durationInHours * 60 * 60;
        document.cookie = `_aff_ref=${aff}; path=/; max-age=${maxAgeSeconds}; SameSite=Lax`;
      } catch (err) {
        console.error("Failed to fetch affiliate expiry:", err);
      }
    };

    fetchExpiry();
 }, [aff]);

 return null;
}
